class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      let itemsToChange = {};
      if (event.target.closest('[data-bundle-item]')) {
        // get the line item key for each bundle product and add it to the itemsToChange object where 0 is the new quantity
        event.target
          .closest('[data-bundle-item]')
          .querySelectorAll('[data-group-item]')
          .forEach(
            (lineItem) => (itemsToChange[lineItem.dataset.lineItemKey] = 0),
          );

        this.closest('cart-items').updateQuantity(
          routes.cart_update_url,
          itemsToChange,
          null,
        );
      } else {
        itemsToChange = {
          line: +this.dataset.index,
          quantity: 0,
        };
        this.closest('cart-items').updateQuantity(
          `${routes.cart_change_url}.js`,
          itemsToChange,
          +this.dataset.index,
        );
      }
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    // Check if we have extra options on the HTML
    this.options = {};

    if (this && this.dataset && this.dataset.options) {
      const jsonOptions = JSON.parse(this.dataset.options);

      if (jsonOptions) {
        this.options = {
          ...this.options,
          ...jsonOptions,
        };
      }
    }

    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status',
    );
    this.isCartPage = document.body.classList.contains('template-cart');
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]'),
    ).reduce((total, quantityInput) => total + +quantityInput.value, 0);

    // when the free gift is added, update the item count of the cart
    window.addEventListener('free-gift-added', () => {
      setTimeout(() => {
        this.currentItemCount = Array.from(
          this.querySelectorAll('[name="updates[]"]'),
        ).reduce(
          (total, quantityInput) => total + parseInt(quantityInput.value),
          0,
        );
      }, 250);
    });

    this.debouncedOnChange = debounce((event) => {
      if (event.target != document.getElementById('Cart-note')) {
        this.onChange(event);
      }
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // get the cookie with the options, this should be an array once parsed
    this.setOptions = getCookie('configurator-options');

    // check set-creator cookie to see if a set has been added
    this.initSet();

    // add eventlistener for the bundle remove button
    this.querySelectorAll('[data-remove-bundle]')?.forEach((trigger) =>
      trigger.addEventListener('click', this.removeMultiple.bind(this)),
    );
  }

  initSet() {
    // if the global cookie doesn't exist, we don't have to check for a set
    if (!this.setOptions) return;

    this.configuration = {};

    this.setOptions.forEach((option) => {
      const setOption = getCookie(`configurator-${option}`);

      if (!setOption) return;

      // remove the temp cookie
      removeCookie(`temp-configurator-${option}`);

      // create a new object with the cookie value
      this.configuration[option] = setOption;

      // Cookie can be available but that doesn't mean the items have been added to the cart, so we need to check that first.
      if (!this.configuration[option].inCart) return;

      // update the page content
      const wrapper = this.querySelector(`[data-set-wrapper="${option}"]`);
      wrapper?.querySelectorAll('[data-set-page-link]').forEach((link) => {
        const url = this.configuration[option].page;
        // If this is a direct link to the batteries, add a parameter to the url
        link.dataset.setPageLinkBattery !== undefined
          ? (link.href = `${url}?show=batteries`)
          : (link.href = url);
      });

      // update the battery text
      document
        .querySelectorAll('[data-set-creator-battery-text]')
        ?.forEach((text) =>
          text.classList.toggle(
            'hidden',
            this.configuration[option].hasBatteries,
          ),
        );

      // add eventlistener for the set remove button
      this.querySelectorAll('[data-remove-set]')?.forEach((trigger) =>
        trigger.addEventListener('click', this.removeMultiple.bind(this)),
      );
    });
  }

  onChange(event) {
    let itemsToChange = {};

    // check if the max is not exceeded
    const quantity =
      +event.target.value > +event.target.max
        ? +event.target.max
        : +event.target.value;

    if (event.target.closest('[data-bundle-item]')) {
      // get the line item key for each bundle product and add it to the itemsToChange object where 0 is the new quantity
      event.target
        .closest('[data-bundle-item]')
        .querySelectorAll('[data-group-item]')
        .forEach(
          (lineItem) =>
            (itemsToChange[lineItem.dataset.lineItemKey] = quantity),
        );

      this.updateQuantity(
        routes.cart_update_url,
        itemsToChange,
        +event.target.dataset.index,
      );
    } else {
      itemsToChange = {
        line: +event.target.dataset.index,
        quantity,
      };
      this.updateQuantity(
        `${routes.cart_change_url}.js`,
        itemsToChange,
        +event.target.dataset.index,
      );
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'main-cart-upsell',
        section: document.getElementById('main-cart-upsell')?.dataset.id,
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  /**
   * Will remove a bundle or a set, based on the event target. Elements with data-group-item should have the line item key.
   * @param {*} event
   */
  async removeMultiple(event) {
    this.enableLoading();

    const updates = {};
    const type =
      event.target.dataset.removeSet !== undefined ? 'isSet' : 'isBundle';
    const elementWrapper =
      type === 'isSet'
        ? event.target.closest('[data-set-wrapper]')
        : event.target
          .closest('.cart-item')
          .querySelector('[data-bundle-wrapper]');

    // get the line item key from each remove button and add it to the updates object where 0 is the new quantity
    elementWrapper
      .querySelectorAll('[data-group-item]')
      .forEach((lineItem) => (updates[lineItem.dataset.lineItemKey] = 0));

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_update_url}.js`, {
        ...fetchConfig('javascript'),
        ...{ body },
      });
      if (!response.ok) throw new Error(response.status);

      // On success: update the sections
      const parsedState = await response.json();

      if (type === 'isSet') {
        const set = elementWrapper.dataset.setWrapper;

        // trigger a window event that we use in the set-creator.js
        window.dispatchEvent(
          new CustomEvent('set-removed', {
            bubbles: true,
            detail: {
              set,
            },
          }),
        );

        // remove the cookie=
        removeCookie(`configurator-${set}`);

        // re-init the set in case there is another one in the cart
        this.initSet();

        // Send Tealium event. For sets and bundles, get all items and their object and map through them to get all ids, titles, etc.
        if (window.tealium.useTealium) {
          const objWrapper =
            type === 'isSet'
              ? event.target.closest('[data-set-wrapper]')
              : event.target.closest('[data-bundle-item]');

          if (objWrapper) {
            let setProductObjects = [];
            objWrapper.querySelectorAll('[data-product-obj]').forEach((obj) => {
              const parsedObj = JSON.parse(obj.dataset.productObj);
              setProductObjects.push(parsedObj.productObj);
            });

            // fire the event
            tealiumRemoveProducts({
              product_id: setProductObjects.map(
                (product) => product.product_id,
              ),
              product_name: setProductObjects.map(
                (product) => product.product_name,
              ),
              product_price: setProductObjects.map((product) =>
                (product.product_price / 100.0).toFixed(2),
              ),
              product_brand: setProductObjects.map(
                (product) => product.product_brand,
              ),
              product_quantity: setProductObjects.map(
                (product) => product.product_quantity,
              ),
            });
          }
        }
      }

      // update page content
      this.afterUpdate(parsedState, null, false);
    } catch (error) {
      debug() && console.log('Error removing set', error);
      this.afterUpdateError();
    }
  }

  async updateQuantity(route, updateObj, line) {
    this.enableLoading();

    // update the body based on the updateObj. When we are updating the cart, the body needs an update key, but when it's only a single item being added, the id and quantity are they keys
    let body = {};
    if (route === routes.cart_update_url) {
      body.updates = updateObj;
    } else {
      body = {
        ...updateObj,
      };
    }

    body.sections = this.getSectionsToRender().map(
      (section) => section.section,
    );
    body.sections_url = window.location.pathname;
    body = JSON.stringify(body);

    try {
      const response = await fetch(`${route}`, {
        ...fetchConfig('javascript'),
        ...{ body },
      });
      if (!response.ok) throw new Error(response.status);

      // On success: update the sections
      const parsedState = await response.json();
      if (updateObj.quantity === 0) {
        if (window.tealium.useTealium) {
          // get the product object with the tealium values
          const productJson = JSON.parse(
            this.querySelector(`#CartItem-${line}`).dataset.productObj,
          );

          // Send Tealium event
          tealiumRemoveProducts({
            ...productJson.productObj,
            product_price: (
              productJson.productObj.product_price / 100.0
            ).toFixed(2),
          });
        }
      }

      // update page content
      this.afterUpdate(parsedState, line);
    } catch (error) {
      debug() && console.log('Error updating cart', error);

      this.afterUpdateError();
    } finally {
      // always run this so the event listeners are added again
      this.initSet();
    }
  }

  afterUpdate(parsedState, line, updateQty = true) {
    // cart is empty
    document
      .querySelector('[data-cart-drawer]')
      ?.classList.toggle('cart-drawer-is-empty', parsedState.item_count === 0);
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    document
      .getElementById('main-cart-footer')
      ?.classList.toggle('is-empty', parsedState.item_count === 0);

    this.renderContents(parsedState);

    if (line !== null) {
      document
        .getElementById(`CartItem-${line}`)
        ?.querySelector('input')
        ?.focus();
    }

    // re-add click listeners for set remove and bundle remove
    this.querySelectorAll('[data-remove-set]')?.forEach((trigger) =>
      trigger.addEventListener('click', this.removeMultiple.bind(this)),
    );

    this.querySelectorAll('[data-remove-bundle]')?.forEach((trigger) =>
      trigger.addEventListener('click', this.removeMultiple.bind(this)),
    );

    // launch a global event with the updated item
    window.dispatchEvent(
      new CustomEvent('cart-update', {
        bubbles: true,
        detail: {
          item: parsedState.items[+line - 1],
        },
      }),
    );

    // only disable the loader when we don't have to check for the gift
    this.updateLiveRegions(line, parsedState.item_count, updateQty);
    this.disableLoading();
  }

  afterUpdateError() {
    document.querySelector('.loading-overlay').classList.add('hidden');
    document.getElementById('cart-errors').textContent =
      window.cartStrings.error;
    this.disableLoading();
  }

  // show error texts, should not be deleted.
  updateLiveRegions(line, itemCount, updateQty) {
    if (this.currentItemCount === itemCount && updateQty) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value,
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (!document.getElementById(section.id)) {
        return;
      }

      const selector = section.selector ? section.selector : `#${section.id}`; // fallback for product carousel where it needs the id that is the same as the selector
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      if (
        elementToReplace &&
        this.getSectionInnerHTML(
          parsedState.sections[section.section],
          selector,
        )
      ) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          selector,
        );
      }
    });
  }

  getSectionInnerHTML(html, selector) {
    const newContent = new DOMParser().parseFromString(html, 'text/html');
    if (newContent.querySelector(selector)) {
      return newContent.querySelector(selector).innerHTML;
    }
  }

  enableLoading() {
    document
      .getElementById('main-cart-items')
      .classList.add('cart-items-disabled');
    document
      .querySelector('.js-cart-footer-contents')
      .classList.add('cart-items-disabled');
    document.querySelector('.cart-ctas').classList.add('cart-items-disabled');

    document
      .querySelector('#main-cart-footer .loading-overlay')
      .classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document
      .getElementById('main-cart-items')
      .classList.remove('cart-items-disabled');
    document
      .querySelector('.js-cart-footer-contents')
      .classList.remove('cart-items-disabled');
    document
      .querySelector('.cart-ctas')
      .classList.remove('cart-items-disabled');
    document
      .querySelector('#main-cart-footer .loading-overlay')
      .classList.add('hidden');
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}
